(() => {
  const menus = Array.from(document.querySelectorAll('[data-iva-site-menu]'));
  if (!menus.length) return;
  let lastTrigger = null;
  function setLock() { document.documentElement.classList.toggle('iva-menu-is-open', menus.some(m => m.open)); }
  function close(menu, restoreFocus = true) {
    if (!menu.open) return;
    menu.open = false;
    menu.querySelectorAll('.iva-menu-group[open]').forEach(item => { item.open = false; });
    setLock();
    if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
  }
  menus.forEach(menu => {
    menu.querySelectorAll('[data-iva-close]').forEach(el => el.addEventListener('click', () => close(menu)));
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        lastTrigger = menu.querySelector(':scope > summary');
        menus.filter(other => other !== menu && other.open).forEach(other => close(other, false));
        setLock();
        // Send focus into the drawer once visible, not underneath its backdrop.
        menu.querySelector('.iva-menu-close')?.focus();
      } else setLock();
    });
    menu.querySelectorAll('.iva-menu-panel a').forEach(link => link.addEventListener('click', () => close(menu, false)));
  });
  document.addEventListener('keydown', event => {
    const active = menus.find(m => m.open);
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(active); return; }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(active.querySelector('.iva-menu-panel').querySelectorAll('a[href],button:not([disabled]),summary'))
      .filter(el => el.getClientRects().length > 0);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
  });
  window.addEventListener('pagehide', () => menus.forEach(m => { m.open = false; }));
})();
